import React from 'react';
import { Activity, Target, CheckCircle, XCircle, Zap } from 'lucide-react';

interface EditorStatusBarProps {
  fileName?: string;
  language?: string;
  line?: number;
  column?: number;
  buildCredits?: number;
  buildCreditsUsage?: number;
  aiProvider?: string;
  testResults?: {
    passed: number;
    failed: number;
    total: number;
  };
  performanceMetrics?: {
    renderTime: number;
    memoryUsage: number;
  };
}

const EditorStatusBar: React.FC<EditorStatusBarProps> = ({
  fileName = 'main.py',
  language = 'python',
  line = 1,
  column = 1,
  buildCredits = 0,
  buildCreditsUsage = 0,
  aiProvider = 'arcOS',
  testResults = { passed: 0, failed: 0, total: 0 },
  performanceMetrics = { renderTime: 0, memoryUsage: 0 }
}) => {
  return (
    <div className="flex items-center justify-between px-3 py-1 bg-slate-800/30 border-t border-slate-600/30 text-xs">
      <div className="flex items-center space-x-4">
        <span className="text-foreground font-medium">{fileName}</span>
        <span className="text-slate-400">{language}</span>
        <span className="text-slate-400">Ln {line}, Col {column}</span>
      </div>
      
      <div className="flex items-center space-x-4">
        {testResults.total > 0 && (
          <div className="flex items-center space-x-2">
            <div className="flex items-center space-x-1 text-green-400">
              <CheckCircle className="h-3 w-3" />
              <span>{testResults.passed}</span>
            </div>
            <div className="flex items-center space-x-1 text-red-400">
              <XCircle className="h-3 w-3" />
              <span>{testResults.failed}</span>
            </div>
          </div>
        )}
        
        {performanceMetrics.renderTime > 0 && (
          <div className="flex items-center space-x-2">
            <div className="flex items-center space-x-1 text-blue-400">
              <Activity className="h-3 w-3" />
              <span>{performanceMetrics.renderTime}ms</span>
            </div>
            <div className="flex items-center space-x-1 text-purple-400">
              <Target className="h-3 w-3" />
              <span>{performanceMetrics.memoryUsage}MB</span>
            </div>
          </div>
        )}
        
        {(buildCredits > 0 || buildCreditsUsage > 0) && (
          <span className="text-slate-400">{buildCredits || buildCreditsUsage} BC</span>
        )}
        
        <div className="flex items-center space-x-1 text-emerald-400">
          <Zap className="h-3 w-3" />
          <span>{aiProvider}</span>
        </div>
      </div>
    </div>
  );
};

export default EditorStatusBar;
